export default __webpack_public_path__ + "static/media/more.0b015ed5.svg";